import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Heading } from '@warrenbrasil/nebraska-web';
import { AllocationChart } from '@/modules/catalog/components/AllocationChart';
import { AllocationChartLegend } from './components/AllocationChartLegend';

import { IAllocation } from '@/modules/catalog/services/funds';

interface Props {
  data: IAllocation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Allocation',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: IAllocation;
};



const title = computed(() => {
  return props.data?.title || '-';
});

return { __sfc: true,props, title, Heading, AllocationChart, AllocationChartLegend }
}

})